module.exports = __webpack_public_path__ + "static/media/ykb.a2c6c605.png";